import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { RelationsController } from './relations.controller';
import { RelationsService } from './relations.service';
import { TypeOrmModule } from '@nestjs/typeorm';
import { Relations } from './relation.entity';
import { RelationsAdapter } from './dto/relation.adapter';
import { LogsService } from '@gtpl/shared-services/user-logs';

@Module({
  imports: [
    TypeOrmModule.forFeature([Relations]),
  ],
  controllers: [RelationsController],
  providers: [RelationsService,RelationsAdapter,ApplicationExceptionHandler,LogsService]
})
export class RelationsModule {}